var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-main text-banner text-center"},[_c('h2',[_c('strong',[_vm._v("You are successfully logged out!")])])])
}]

export { render, staticRenderFns }